import { Modal, Row, Col, Container } from 'react-bootstrap';

const ProductDetailModal = ({ show, onHide, product }) => {
    if (!product) return null;

    return (
        <Modal show={show} onHide={onHide} size="lg" centered className="product-detail-modal">
            <Modal.Header closeButton className="border-0 pb-0">
            </Modal.Header>

            <Modal.Body className="pt-4">
                <Container>
                    <Row>
                        <div className="text-center">
                            <div className="custom-title-bg">
                                <h3 className="text-uppercase">{product.productName}</h3>
                            </div>
                        </div>
                    </Row>
                    <Row className="mb-0 align-items-center">
                        <Col md={5} className="text-center">
                            <img src={product.desktopRendition} alt={product.productName} className="img-fluid main-product-img" />
                        </Col>
                        <Col md={7}>
                            <h5 className="fw-bold text-dark">Descripción General</h5>
                            <p className="text-muted">{product.desc}</p>
                        </Col>
                    </Row>

                    <hr className="my-4" />

                    <h5 className="fw-bold mb-4 text-uppercase" style={{ color: '#1b337e' }}>
                        Modelos Disponibles
                    </h5>

                    {product.models && product.models.map((version, index) => (
                        <div key={index} className="version-item p-3 mb-3 d-flex align-items-center">
                            <div className="version-img-container me-4">
                                <img src={version.desktopRendition} alt={version.label} />
                            </div>
                            <div className="version-info">
                                <h6 className="fw-bold mb-1 text-dark">{version.label}</h6>
                                <p className="mb-0 text-muted small">{version.longDescription}</p>
                            </div>
                        </div>
                    ))}
                </Container>
            </Modal.Body>
        </Modal>
    );
};

export default ProductDetailModal;